import React, {useEffect, useRef, useState} from "react";
import {
    Button,
    CircularProgress,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle, Table, TableBody, TableRow,
    Typography, withStyles
} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import AppColors from "../colors/AppColors";
import '../input.css'
import UsersManager from "../managers/UsersManager";
import axios from "axios";
import RequestUtils from "../utils/RequestUtils";
import EndPoints from "../net/EndPoints";
import MuiTableCell from "@material-ui/core/TableCell";
import MaterialSnackBar from "../views/MaterialSnackBar";
import {Constants} from "../constants/Constants";
import ExceptionUtils from "../utils/ExceptionUtils";
import {useDispatch} from "react-redux";
import MuiAlert from '@material-ui/lab/Alert';

const TableCell = withStyles({
    root: {
        borderBottom: "none"
    }
})(MuiTableCell);

export default function BitcoinWithdrawalDialog(props: any) {

    let open = props.open;
    const onDialogClosed = props.onDialogClosed;
    const [openDialog, setOpenDialog] = React.useState(open);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [errorEncountered, setErrorEncountered] = useState(false);
    const [encounteredErrorMessage, setEncounteredErrorMessage] = useState("Oops! Error Starting Withdrawal Process. Please review your internet\n" +
        "                    connection and try again.");
    const [transactionFee, setTransactionFee] = useState(0);
    const withdrawalRef = useRef<HTMLInputElement>(null);
    const withdrawalAddressRef = useRef<HTMLInputElement>(null);
    const [fetchingTransactionFee, setFetchingTransactionFee] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackSeverity, setSnackSeverity] = useState("error");
    const [withdrawalInProgress, setWithdrawalInProgress] = useState(false);
    const [withdrawalSuccessMessage, setWithdrawalSuccessMessage] = useState("");

    const dispatch = useDispatch();

    const handleSnackClose = () => {
        setOpenSnack(false);
    }

    useEffect(() => {
        setOpenDialog(open);
        fetchTransactionFees();
    }, [open]);

    const fetchTransactionFees = () => {
        setFetchingTransactionFee(true);
        axios.get(EndPoints.GET_TRANSACTION_FEE, {
            headers: RequestUtils.getHeaders()
        }).then(response => {
            setTransactionFee(response["data"]["data"].toFixed(8));
            setFetchingTransactionFee(false);
        }).catch(_error => {
            setFetchingTransactionFee(false);
            setErrorEncountered(true);
        });
    }

    const handleDialogClose = () => {
        setOpenDialog(false);
        setErrorEncountered(false);
        onDialogClosed();
    }

    const fillInTotalUserBalance = () => {
        const loggedInUser = JSON.parse(UsersManager.getLoggedInUser() as string)
        const userBalance = loggedInUser["balance"];
        withdrawalRef.current!.value = userBalance.toFixed(8);
    }

    const useProfileAddress = () => {
        const loggedInUser = JSON.parse(UsersManager.getLoggedInUser() as string)
        // noinspection UnnecessaryLocalVariableJS
        const withdrawalAddress = loggedInUser["withdrawalAddress"];
        withdrawalAddressRef.current!.value = withdrawalAddress;
    }

    const withDraw = () => {
        let withdrawalAmount = withdrawalRef.current!.value
        if (!withdrawalAmount) {
            setSnackMessage("Enter withdrawal amount");
            setOpenSnack(true);
            return;
        }
        let withdrawalAddress = withdrawalAddressRef.current!.value
        if (!withdrawalAddress) {
            setSnackMessage("Enter withdrawal address");
            setOpenSnack(true);
            return;
        }
        let requestBody = {
            [Constants.WITHDRAWAL_AMOUNT]: withdrawalAmount,
            [Constants.WITHDRAWAL_ADDRESS]: withdrawalAddress
        };
        setWithdrawalInProgress(true);
        axios.post(EndPoints.WITHDRAW_BITCOINS, requestBody, {
            headers: RequestUtils.getHeaders()
        }).then(response => {
            let data = response["data"]
            let user = data["data"];
            let message = data["message"];
            setWithdrawalInProgress(false);
            UsersManager.saveLoggedInUser(JSON.stringify(user));
            dispatch({
                type: Constants.LOGGED_IN_USER_DATA_CHANGED,
                payload: JSON.stringify(user)
            });
            setWithdrawalSuccessMessage(message);
        }).catch(error => {
            setWithdrawalInProgress(false);
            setEncounteredErrorMessage(ExceptionUtils.getErrorMessage(error));
            setErrorEncountered(true);
        });
    }

    const ErrorEncounteredView = React.forwardRef(function (props: any, ref: any) {
        return <DialogContent>
            <div>
                <Typography align={"center"}>{encounteredErrorMessage}</Typography>
            </div>
        </DialogContent>
    });

    // noinspection JSUnusedLocalSymbols
    const GeneratingTransactionFeeView = React.forwardRef(function (props: any, ref: any) {
        return <DialogContent>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <CircularProgress/>
                <Typography>Please wait...</Typography>
            </div>
        </DialogContent>
    });

    const MainView = React.forwardRef(function (props: any, ref: any) {

        return <DialogContent>
            <div style={{
                display: 'flex',
                flexDirection: 'column'
            }}>
                <Typography
                    align={"center"}
                    style={{
                        background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                        padding: 10,
                        textAlign: 'center',
                        fontSize: 16,
                        marginTop: 15,
                        fontWeight: 600,
                        color: 'white',
                        borderRadius: '5px 5px 0 0',
                    }}>MIN. WITHDRAW: 0.00030000 BTC</Typography>
            </div>
            <Table style={{
                backgroundColor: '#fdfbec',
                border: 'none'
            }}>
                <TableBody style={{
                    borderCollapse: 'collapse',
                    border: 'none'
                }}>
                    <TableRow style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        border: '1px solid grey',
                    }}>
                        <TableCell>
                            <Typography
                                align={"center"}
                                style={{
                                    textAlign: 'center',
                                    padding: 10,
                                    fontWeight: 600,
                                }}>TIME TAKEN</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography
                                align={"center"}
                                style={{
                                    textAlign: 'center',
                                    padding: 10
                                }}>~15 Minutes</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        border: '1px solid grey',
                    }}>
                        <TableCell>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                            }}>
                                <Typography
                                    align={"center"}
                                    style={{
                                        textAlign: 'center',
                                        padding: 10,
                                        fontWeight: 600,
                                    }}>AMOUNT</Typography>
                                <Typography
                                    onClick={fillInTotalUserBalance}
                                    align={"center"}
                                    style={{
                                        textAlign: 'center',
                                        padding: 10,
                                        fontSize: 13,
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                    }} dangerouslySetInnerHTML={{
                                    __html: `(<b style="color:${AppColors.BLUE}">WITHDRAW ALL</b>)`
                                }}/>

                            </div>
                        </TableCell>
                        <TableCell>
                            <input
                                ref={withdrawalRef}
                                placeholder={"Enter withdrawal amount"}
                                style={{
                                    width: '90%',
                                    textAlign: 'center',
                                    padding: 10,
                                    fontStyle: 'bold',
                                    fontWeight: 600,
                                    backgroundColor: 'white',
                                    borderRadius: 1
                                }}/>
                        </TableCell>
                    </TableRow>
                    <TableRow style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        border: '1px solid grey',
                    }}>
                        <TableCell>
                            <Typography
                                align={"center"}
                                style={{
                                    textAlign: 'center',
                                    padding: 10,
                                    fontWeight: 600,
                                }}>TRANSACTION FEES</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography
                                align={"center"}
                                style={{
                                    textAlign: 'center',
                                    padding: 10
                                }}>{transactionFee}</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        border: '1px solid grey',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap'
                    }}>
                        <TableCell>
                            <Typography
                                align={"center"}
                                style={{
                                    textAlign: 'center',
                                    padding: 10,
                                    fontWeight: 600,
                                }}>AMOUNT DEDUCTED</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography
                                align={"center"}
                                style={{
                                    textAlign: 'center',
                                    padding: 10
                                }} dangerouslySetInnerHTML={{
                                __html: `<b style="font-weight: bold">${transactionFee}</b> BTC`
                            }}/>
                        </TableCell>
                    </TableRow>
                    <TableRow style={{
                        border: '1px solid grey',
                    }}>
                        <TableCell colSpan={2}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography
                                    align={"center"}
                                    style={{
                                        textAlign: 'center',
                                        padding: 10,
                                        fontWeight: 600,
                                    }}>BITCOIN ADDRESS</Typography>
                                <Typography
                                    onClick={useProfileAddress}
                                    align={"center"}
                                    style={{
                                        textAlign: 'center',
                                        padding: 10,
                                        fontSize: 12,
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                    }} dangerouslySetInnerHTML={{
                                    __html: `(<b style="color:${AppColors.BLUE}">USE PROFILE ADDRESS</b>)`
                                }}/>
                            </div>
                        </TableCell>
                    </TableRow>
                    <TableRow style={{
                        border: '1px solid grey',
                    }}>
                        <TableCell colSpan={2}>
                            <input
                                ref={withdrawalAddressRef}
                                placeholder={"Enter withdrawal Address"}
                                style={{
                                    width: '95%',
                                    margin: 'auto',
                                    textAlign: 'center',
                                    padding: 10,
                                    fontStyle: 'bold',
                                    fontWeight: 600,
                                    backgroundColor: 'white',
                                    borderRadius: 1
                                }}/>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2}>
                            <Button
                                disabled={withdrawalInProgress}
                                onClick={withDraw}
                                style={{
                                    width: '100%',
                                    margin: 'auto',
                                    color: 'white',
                                    background: 'linear-gradient(to bottom,#FFA71A 5%,#CC7000 100%)'
                                }}>WITHDRAW</Button>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </DialogContent>
    });
    return (<Dialog disableBackdropClick={true}
                    fullScreen={fullScreen}
                    open={openDialog}
                    onClose={() => handleDialogClose()}
                    aria-labelledby="responsive-dialog-title">
        <DialogTitle style={{
            textAlign: 'center',
            fontWeight: 600,
            fontStyle: 'bold'
        }} id="responsive-dialog-title">{"WITHDRAW BITCOINS"}</DialogTitle>
        {
            fetchingTransactionFee &&
            <GeneratingTransactionFeeView/>
        }
        {
            transactionFee > 0 && !errorEncountered && !fetchingTransactionFee &&
            <MainView/>
        }
        {
            errorEncountered && !fetchingTransactionFee &&
            <ErrorEncounteredView/>
        }
        {
            withdrawalSuccessMessage !== "" &&
            <MuiAlert severity="success">{withdrawalSuccessMessage}</MuiAlert>
        }
        <DialogActions>
            <Button autoFocus onClick={handleDialogClose} color="primary">
                CLOSE
            </Button>
        </DialogActions>
        <MaterialSnackBar
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center'
            }}
            open={openSnack}
            onSnackClosed={handleSnackClose}
            message={snackMessage}
            severity={snackSeverity}/>
    </Dialog>);
}